import React from 'react'
import ModalComponent from 'components/common/ModalComponent'
import { showAlert } from 'services/alerts.service'
import { getFormattedMissingFieldsMessage } from 'utils/index'

const WorkerModal = ({ isOpen, onClose, worker, onSave }) => {
  if (!worker) return null

  const handleSave = async (formData) => {
    const htmlMessage = getFormattedMissingFieldsMessage(formData, ['firstName', 'lastName'])
    if (htmlMessage !== '') {
      showAlert({
        html: htmlMessage,
        icon: 'warning'
      })
      return
    }

    const dataToSave = worker?.workerId ? formData : { ...formData, workerId: undefined }
    onSave(dataToSave)
    // onClose()
  }

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={worker?.workerId ? 'Update Worker' : 'Create Worker'}
      initialData={{
        workerId: worker?.workerId || '',
        oldId: worker?.oldId || '',
        firstName: worker?.firstName || '',
        lastName: worker?.lastName || '',
        phoneNumber: worker?.phoneNumber || '',
        isActive: worker?.isActive ?? true,
        comments: worker?.comments || ''
      }}
      onSave={handleSave}
    >
      {({ formData, handleChange }) => (
        <form className='space-y-4 w-96' autoComplete='off'>
          {worker?.workerId > 0 && (
            <label className='block text-sm font-medium'>
              Worker ID
              <input
                type='text'
                value={formData.workerId}
                disabled
                className='w-full mt-1 p-2 border rounded bg-gray-100'
              />
            </label>
          )}

          <label className='block text-sm font-medium'>
            Pick Id / Old Id
            <input
              type='text'
              name='oldId'
              value={formData.oldId}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            />
          </label>

          <label className='block text-sm font-medium'>
            First Name *
            <input
              type='text'
              name='firstName'
              value={formData.firstName}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            />
          </label>

          <label className='block text-sm font-medium'>
            Last Name *
            <input
              type='text'
              name='lastName'
              value={formData.lastName}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            />
          </label>

          <label className='block text-sm font-medium'>
            Phone Number
            <input
              type='text'
              name='phoneNumber'
              value={formData.phoneNumber}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            />
          </label>

          <label className='flex items-center space-x-2 text-sm font-medium'>
            <input
              type='checkbox'
              name='isActive'
              checked={formData.isActive}
              onChange={handleChange}
              className='w-5 h-5 text-green-600 border-gray-300 rounded focus:ring focus:ring-green-300'
            />
            <span>Active</span>
          </label>

          <label className='block text-sm font-medium'>
            Comments
            <textarea
              name='comments'
              value={formData.comments}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            />
          </label>
        </form>
      )}
    </ModalComponent>
  )
}

export default WorkerModal
